import { produce } from "immer";
import {
    IAutomationState,
    IGraphNode,
    IWorkflowFinishEmail,
    IWorkflowFinishEmailAPIPayloadResponse,
  } from "./automation.types";
import { getUniqueId } from "../../helpers";
  
  export const parseFinialEmailApiToLocalPayload = (
    payload: IWorkflowFinishEmailAPIPayloadResponse
  ): IWorkflowFinishEmail => {
    const finalData: IWorkflowFinishEmail = { 
      workflow_action_code: payload.workflow_action_code,
      workflow_basic_code: payload.workflow_basic_code,
      workflow_action_email_code: payload.workflow_action_email_code,
      emailsTo: [],
      emailsCC: [],
      emailsBCC: [],
      apiTo: [],
      apiCC: [],
      apiBCC: [],
      call_type: payload.call_type,
      nodes: payload.nodes,
      sending_order: payload.sending_order,
      status: payload.status,
      template_code: payload.template_code,
      variablesTo:[],
      variablesCC: [],
      variablesBCC: [],
     };
  
    if (payload.call_type === "VARIABLE") {
      for (const toData of payload.to) {
        const data = toData.split(".");
        if (data.length > 0) {
          finalData.variablesTo.push({
            view: data[0],
            columnName: data[1] || "",
          });
        }
      }
      for (const ccData of payload.cc) {
          const data = ccData.split(".");
          if (data.length > 0) {
            finalData.variablesCC.push({
              view: data[0],
              columnName: data[1] || "",
            });
          }
        }
        for (const bccData of payload.bcc) {
          const data = bccData.split(".");
          if (data.length > 0) {
            finalData.variablesBCC.push({
              view: data[0],
              columnName: data[1] || "",
            });
          }
        }
    }
    else if (payload.call_type === "API") {
      for (const toData of payload.to) {
        finalData.apiTo.push({
          api: toData.api,
          emailColumn: toData.emailColumn,
          userName: toData.userName,
          queryParams: toData.queryParams,
          endpoint: toData.endpoint,
          endpointType: toData.endpointType,
          module_name: toData.module_name,
        });
      }
      for (const ccData of payload.cc) {
        finalData.apiCC.push({
          api: ccData.api,
          emailColumn: ccData.emailColumn,
          userName: ccData.userName,
          queryParams: ccData.queryParams,
          endpoint: ccData.endpoint,
          endpointType: ccData.endpointType,
          module_name: ccData.module_name,
        });
        }
        for (const bccData of payload.bcc) {
          finalData.apiBCC.push({
            api: bccData.api,
            emailColumn: bccData.emailColumn,
            userName: bccData.userName,
            queryParams: bccData.queryParams,
            endpoint: bccData.endpoint,
            endpointType: bccData.endpointType,
            module_name: bccData.module_name,
          });
        }
    }
    else if(payload.call_type === "EMAIL_ADDRESS"){
      finalData.emailsTo = payload.to;
      finalData.emailsCC = payload.cc;
      finalData.emailsBCC = payload.bcc;
    }
  
  
    return finalData;
  };
  





  export const updateNodesWithPlaceholderAndEdges = (state: IAutomationState, node: IGraphNode, isDelete: boolean ) =>{
    const newState = produce(state, draftState=>{
        const index = draftState.graphData.nodes.findIndex(x=>x.id === node.id);
        if(isDelete){
         
            if(index > -1){
                draftState.graphData.nodes.splice(index, 1);
            }
        }
        else if(index > -1){
            draftState.graphData.nodes[index] = {
                ...draftState.graphData.nodes[index],
                data: node.data,
            };
      
        }
        else {
            const placeholderNodeId = getUniqueId();
          
            draftState.graphData.nodes.push(node);
            const placeholderNodeIndex = draftState.graphData.nodes.findIndex(x=>x.type === "placeholder");
            if(placeholderNodeIndex > -1){
                draftState.graphData.nodes.splice(placeholderNodeIndex, 1);
            }
            draftState.graphData.nodes.push({
                id: placeholderNodeId,
                position: { x: 0, y:0 },
                type: 'placeholder',
                data: { label: '+',payload: {} as any },
            });

            // const childPlaceholderEdge = {
            //     id: `${node.id}=>${placeholderNodeId}`,
            //     source: node.id,
            //     target: placeholderNodeId,
            //     type: 'placeholder',
            //   };
            //   draftState.graphData.edges.push(childPlaceholderEdge as any)
        }
        draftState.graphData.edges=[];

        for (let i = 0; i < draftState.graphData.nodes.length; i++) {
            if (i !== 0) {
              const targetId = draftState.graphData.nodes[i].id;
              const sourceId = draftState.graphData.nodes[i - 1].id;
              draftState.graphData.edges.push({
                id: sourceId + "=>" + targetId,
                source: sourceId,
                target: targetId,
                type: draftState.graphData.nodes[i].type,
              });
            }
          
        }
    });
    return newState;
}